import { useState, useEffect } from 'react'
import NavigationBar from "./NavigationBar";
import LandingPage from "./LandingPage";
import Onboarding from "./Onboarding";
import Profile from "./Profile";
import Takes from "./Takes";
import VotesDetail from "./VotesDetail";
import EventFeed from "./EventFeed";
import VorPhase from "./VorPhase";
import NachPhase from "./NachPhase";
import ThesisDetail from "./ThesisDetail";
import Graben from "./Standing";
import Users from "./Users";

import TranslatedApp from "./TranslatedApp"

import './App.css';

import { Switch, BrowserRouter, Routes, Route } from "react-router-dom";
import { TransitionGroup, CSSTransition } from "react-transition-group";

function App() {

  return (
    <BrowserRouter>
    <TranslatedApp>
      <Route
        render={({ location }) => (
          <TransitionGroup>
            <CSSTransition
              key={location.key}
              timeout={500}
              classNames="fade"
            >
              <Switch location={location}>
                {/* Phase 1 - Vor der Konferenz */}
                <Route path="/vor" component={VorPhase} />

                {/* Phase 2 - Während der Konferenz */}
                <Route path="/takes/:id/votes" component={VotesDetail} />
                <Route path="/takes/:id/detail" component={EventFeed} />
                <Route path="/session/:id" component={EventFeed} />
                <Route path="/feed" component={Takes} />
                <Route path="/theses" component={Takes} />
                <Route path="/takes" render={() => { window.location.replace('/feed'); return null; }} />

                {/* Thesis detail - must be before /takes to avoid prefix collision */}
                <Route path="/thesis/:id" component={ThesisDetail} />

                {/* Die Gräben - standing breadth view */}
                <Route path="/standing" component={Graben} />

                {/* User base composition */}
                <Route path="/users" component={Users} />

                {/* Phase 3 - Nach der Konferenz */}
                <Route path="/nach" component={NachPhase} />

                <Route path="/onboarding" component={Onboarding} />
                <Route path="/profile" component={Profile} />
                <Route path="/" exact component={LandingPage} />
              </Switch>
            </CSSTransition>
          </TransitionGroup>
        )}
      />
  </TranslatedApp>
  </BrowserRouter>
  );
}

export default App;
